<template>
    <div id="customer-msp">
        <v-layout wrap v-if="noResult">
            <v-flex md12>
                <h3 class="headline mb-2">Kein Kunde gefunden</h3>
                <p class="body-1 mb-2">
                    Es konnte kein Kunde für <span class="body-2">{{ scope }}</span> mit der GP Nummer <span class="body-2">{{ gpnumber }}</span> gefunden werden.
                </p>
                <div>
                    <v-btn
                        :to="home"
                        outlined
                        class="ml-0 drei_60-btn"
                    >
                        Zur Suche
                    </v-btn>
                </div>
            </v-flex>
        </v-layout>
        <v-layout wrap justify-space-around v-if="!noResult">
            <v-flex md8>
                <h3 class="headline mb-2">Kundendetails in SAP ({{ scope }})</h3>
                <div>
                    <v-progress-linear
                        :indeterminate="true"
                        :active="loading || inAction"
                    >
                    </v-progress-linear>
                </div>
                <CustomerMsp ref="form" v-if="!loading" />
                <CustomerActionsMsp v-if="!loading" />
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CustomerMsp from '@/components/customer/CustomerMsp.vue';
import CustomerActionsMsp from '@/components/customer/CustomerActionsMsp.vue';
import Route from '@/route';

export default {
    name: 'customer-msp',
    components: {
        CustomerMsp,
        CustomerActionsMsp,
    },
    mounted() {
        const gpNumber = this.$route.params.gp_id;
        const { scope } = this.$route.params;
        this.loadData({ gpNumber, scope }).then(() => {
            if (!this.noResult) {
                this.$refs.form.$refs.customerMspForm.validate();
            }
        }).catch(() => null);
    },
    computed: {
        ...mapState('customerMsp', ['loading', 'inAction', 'noResult', 'scope']),
        home() {
            return {
                name: Route.SEARCH.name,
            };
        },
    },
    methods: {
        ...mapActions('customerMsp', ['loadData']),
    },
};
</script>

<style scoped lang="scss">
</style>
